<app-base-menu-layout [menuOptions]="menuOptions" [headerPath]="'/sysadmin'">
    <div subHeader>
        <h2 appMainHeader>System Administration</h2>
    </div>

    <ng-container content>
        <router-outlet></router-outlet>
    </ng-container>
</app-base-menu-layout>
